import { useEffect, useState } from 'react';
import { HosApiDashboardTopDetailPages } from '../../types/apiTypes';
import { DashboardCardTimespan, DashboardData } from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useTopDetailPages = () => {
  const [topDetailPages, setTopDetailPages] = useState<
    HosApiDashboardTopDetailPages[]
  >([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response && !loading)
      setTopDetailPages(
        response.map((r: HosApiDashboardTopDetailPages) => mapTopDetailPages(r))
      );
  }, [response, loading]);

  const getTopDetailPages = (dateRange?: DashboardCardTimespan) => {
    let url = `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Dashboard/TopDetailPages`;
    if (dateRange)
      url += `?startDate=${dateRange.startDate.toISOString()}&endDate=${dateRange.endDate.toISOString()}`;

    makeRequest(url, 'get');
  };

  return { topDetailPages, getTopDetailPages, loading };
};

const mapTopDetailPages = (
  topDetailPage: HosApiDashboardTopDetailPages
): DashboardData => ({
  id: topDetailPage.PageDetail,
  value: topDetailPage.Count,
});
